import React, { useState, useRef, useEffect } from "react";
import Slider from "react-slick";
import { Container, Form, Button, Card, Row, Col } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import "../styles/MainPage.css";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "bootstrap-icons/font/bootstrap-icons.css";

const cityList = [
  {
    name: "Trip to Montreal",
    imgSrc:
      "https://aebc975c.delivery.rocketcdn.me/wp-content/uploads/2021/12/marc-olivier-jodoin-BG9oZ15a4Xk-unsplash-1-scaled.jpg.webp",
    subtitle:
      "Discover the blend of European charm and vibrant arts in Montreal.",
  },
  {
    name: "Trip to New York",
    imgSrc:
      "https://nyc.eu/wp-content/uploads/2015/07/New_York_City-scaled.jpg",
    subtitle:
      "Experience the city that never sleeps—skyscrapers, Broadway, and more.",
  },
  {
    name: "Trip to Toronto",
    imgSrc: "https://media.nomadicmatt.com/torontoguide.jpg",
    subtitle:
      "Enjoy multicultural vibes, lakefront views, and the CN Tower in Toronto.",
  },
  {
    name: "Trip to Las vegas",
    imgSrc:
      "https://static01.nyt.com/images/2023/04/13/multimedia/13hours-LasVegas-03-zjkm/13hours-LasVegas-03-zjkm-superJumbo.jpg",
    subtitle:
      "Experience the glitz, glamour, and nonstop entertainment of Las Vegas.",
  },
  {
    name: "More cities in Coming...",
    imgSrc:
      "https://cdn.prod.website-files.com/61dfc899a471632619dca9dd/6585d85934a171a9a052c170_traveling-based-on-fare-deals.jpeg",
    subtitle: "Stay tuned for new destinations coming soon! ",
  },
];

const FeaturedCard = ({ imgSrc, title, subtitle }) => {
  return (
    <div className="featured-card">
      <div
        className="featured-card-bg"
        style={{ backgroundImage: `url(${imgSrc})` }}
      >
        <div className="featured-card-overlay">
          <h3 className="featured-card-title">{title}</h3>
          <p className="featured-card-subtitle">{subtitle}</p>
        </div>
      </div>
    </div>
  );
};

const features = [
  {
    icon: "🏨",
    title: "Hotels",
    description:
      "Stay at the best hotels around the world for the best prices.",
  },
  {
    icon: "🍴",
    title: "Restaurants",
    description: "Snag a coveted table at the hottest restaurants.",
  },

  {
    icon: "🗺️",
    title: "Tours",
    description: "Get an insider’s perspective on any location or attraction.",
  },
  {
    icon: "✈️",
    title: "Flights",
    description: "Get real-time airfares for anywhere you want to jet off to.",
    soon: true,
  },
  {
    icon: "🚗",
    title: "Car Rental",
    description: "Unlock deals on any type of wheels and hit the road.",
    soon: true,
  },

  {
    icon: "🎟️",
    title: "Experiences",
    description:
      "Make reservations for your favorite activities, then make memories.",
    soon: true,
  },
];

const MainPage = () => {
  const navigate = useNavigate();

  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [activity, setActivity] = useState("");
  const [budget, setBudget] = useState("");
  const [cuisineInput, setCuisineInput] = useState("");
  const [cuisines, setCuisines] = useState([]);
  const [searchInput, setSearchInput] = useState("");
  const fullTypingText =
    "I would like to go to Montreal for 5 days , including a day trip to Quebec City. I would like to know my options, Please recommend me several plans from basic budget to luxury budget.";
  const aiBoxRef = useRef(null);

  const scrollContainerRef = useRef(null);
  const scrollToCityCards = () => {
    cityCardsRef.current?.scrollIntoView({
      behavior: "smooth",
      block: "start",
    });
  };
  const cityCardsRef = useRef(null);
  const scrollToAiBox = () => {
    aiBoxRef.current?.scrollIntoView({ behavior: "smooth", block: "start" });
  };
  const [activeBubble, setActiveBubble] = useState("hotels");

  useEffect(() => {
    const text =
      "Plan, book, and explore with your FIT guide – anytime, anywhere.";
    let charIndex = 0;
    let isDeleting = false;
    const typewriterElement = document.getElementById("typewriter-description");

    function typeWriter() {
      if (!typewriterElement) return;

      if (isDeleting) {
        typewriterElement.textContent = text.substring(0, charIndex - 1);
        charIndex--;
      } else {
        typewriterElement.textContent = text.substring(0, charIndex + 1);
        charIndex++;
      }

      let typeSpeed = isDeleting ? 30 : 60;

      if (!isDeleting && charIndex === text.length) {
        typeSpeed = 3000; // 完整显示后停留3秒
        isDeleting = true;
      } else if (isDeleting && charIndex === 0) {
        isDeleting = false;
        typeSpeed = 1000; // 清空后停留1秒再开始
      }

      setTimeout(typeWriter, typeSpeed);
    }

    // 延迟500ms开始
    setTimeout(() => {
      typeWriter();
    }, 500);
  }, []);

  const RestaurantPreview = () => (
    <div className="how-it-card">
      <div className="how-it-card-content">
        <h4>Popular Restaurants in Montreal</h4>
        <div className="how-it-tags">
          <span>casual</span>
          <span>under $30</span>
          <span>local favorites</span>
        </div>
        <div className="how-it-restaurant-row">
          <img
            src="https://images.tastet.ca/_/rs:fit:1080:720:false:0/plain/https://tastet-public-production.nyc3.cdn.digitaloceanspaces.com/directus/9120c37b-dbd7-4803-b5d3-ecf28e5aa81b.jpg@jpg"
            alt="L'Express"
            className="how-it-img"
          />
          <div className="how-it-place-info">
            <strong>L'Express</strong>
            <p>Modern French · Old Montreal</p>
            <p className="how-it-price">⭐ 4.7 · Avg $42</p>
          </div>
        </div>
        <div className="how-it-restaurant-row">
          <img
            src="https://i.redd.it/5yc7ncltr6qb1.jpg"
            alt="La Banquise"
            className="how-it-img"
          />
          <div className="how-it-place-info">
            <strong>La Banquise</strong>
            <p>La Banquise · Poutine</p>
            <p className="how-it-price">⭐ 4.8 · Avg $38</p>
          </div>
        </div>
      </div>
    </div>
  );

  const InspirationPreview = () => (
    <div className="how-it-card">
      <div className="how-it-card-content">
        <h4>Inspiration: Local Montreal Escapes</h4>
        <div className="how-it-tags">
          <span>urban</span>
          <span>walks</span>
          <span>culture</span>
        </div>
        <div className="how-it-destination-row">
          <img
            src="https://qc-nu.cpf.ca/files/2022/03/100w1f000001gwb6c2A50.jpeg"
            alt="Old Port"
            className="how-it-img"
          />
          <div className="how-it-place-info">
            <strong>Old Port, Montreal</strong>
            <p>Historic Walks · 18°C · Free</p>
          </div>
        </div>
        <div className="how-it-destination-row">
          <img
            src="https://dynamic-media.tacdn.com/media/photo-o/2f/bb/80/23/caption.jpg?w=700&h=500&s=1"
            alt="Mount Royal"
            className="how-it-img"
          />
          <div className="how-it-place-info">
            <strong>Mount Royal Lookout</strong>
            <p>Scenic Views · 19°C · Free</p>
          </div>
        </div>
      </div>
    </div>
  );

  const TripPreview = () => (
    <div className="how-it-card">
      <div className="how-it-card-content">
        <img
          src="https://www.flyforless.ca/uploads/2/6/5/1/26518951/cheap-flights-to-montreal-2_orig.jpg"
          alt="check in "
          className="how-it-img"
        />
        <h4>Day 1: Arrival and Relax in Montreal</h4>
        <div className="how-it-tags">
          <span>airport transfer</span>
          <span>accommodation</span>
        </div>
        <p>
          Arrive in Montreal and check in at{" "}
          <strong>Travelodge Hotel Montreal</strong>. Stroll through downtown,
          take in the city lights, and enjoy dinner at{" "}
          <strong>Schwartz’s Deli</strong> a local favorite known for its iconic
          smoked meat.
        </p>
        <div className="how-it-trip-item">
          🚕 Private Transfer — 1 day · Pickup available
        </div>
        <div className="how-it-trip-item">
          🏨 Travelodge Hotel Montreal — Affordable comfort near downtown
          attractions
        </div>
      </div>
    </div>
  );
  const HotelPreview = () => (
    <div className="how-it-card">
      <img
        src="https://www.wyndhamhotels.com/content/dam/property-images/en-us/tl/ca/qc/montreal/09782/09782_exterior_view_3.jpg"
        alt="Hotel"
        className="hotel-img"
      />
      <div className="how-it-card-content">
        <h4>Travelodge Hotel Montreal</h4>
        <div className="how-it-tags">
          <span>luxury</span>
          <span>central</span>
          <span>city view</span>
        </div>
        <p>
          "This hotel offers a luxurious experience with elegant rooms and a
          private white sand beach..."
        </p>
        <p className="how-it-price">
          <span className="old-price">CAD $899</span>
          <span className="new-price">$999</span> /night
        </p>
        <button className="how-it-btn">View Hotel</button>
      </div>
    </div>
  );

  //模拟打字
  useEffect(() => {
    let index = 0;
    let currentText = "";

    const typeChar = () => {
      currentText += fullTypingText.charAt(index);
      setSearchInput(currentText);
      index++;

      if (index < fullTypingText.length) {
        setTimeout(typeChar, 15);
      }
    };
    setSearchInput("");
    typeChar();
  }, []);

  const handleFormSubmit = () => {
    if (
      !startDate ||
      !endDate ||
      !activity ||
      !budget ||
      (cuisines.length === 0 && !cuisineInput)
    ) {
      alert("Please fill in all fields for trip planning to move on");
      return;
    }
    console.log({
      startDate,
      endDate,
      activity,
      budget,
      cuisines,
    });
    setStartDate("");
    setEndDate("");
    setActivity("");
    setBudget("");
    setCuisines([]);
    navigate("/budget-tiers");
  };

  const handleSearchSubmit = () => {
    if (!searchInput) {
      alert("Please enter something");
      return;
    }
    console.log("Search Input:", searchInput);

    // 🆕 将用户输入传递到 ChatPage
    navigate("/chat", {
      state: {
        initialMessage: searchInput.trim(),
        fromMainPage: true,
      },
    });

    setSearchInput("");
  };

  const handleSuggestionClick = (suggestionText) => {
    navigate("/chat", {
      state: {
        initialMessage: suggestionText,
        fromMainPage: true,
      },
    });
  };

  const handleSearchKeyDown = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      handleSearchSubmit();
    }
  };

  // scroll to left
  const scrollLeft = () => {
    if (scrollContainerRef.current) {
      scrollContainerRef.current.scrollBy({
        left: -300,
        behavior: "smooth",
      });
    }
  };

  // scroll to right
  const scrollRight = () => {
    if (scrollContainerRef.current) {
      scrollContainerRef.current.scrollBy({
        left: 300,
        behavior: "smooth",
      });
    }
  };
  return (
    //empty tag
    <>
      {/* <HeroSection onExplore={scrollToAiBox} /> */}
      <div className="main-page">
        <div className="jumbotron">
          <Container>
            <div className="jumbotron-content">
              {/* 左侧内容区 */}
              <div className="jumbotron-left">
                {/* 描述文字 - 打字机效果 */}
                <p className="description">
                  <span id="typewriter-description"></span>
                  <span className="typewriter-cursor">|</span>
                </p>

                {/* CTA 按钮 */}
                <button className="main-cta-btn" onClick={scrollToCityCards}>
                  Explore City Getaways
                </button>

                {/* 评分 */}
                <div className="rating-section">
                  <div className="stars">
                    <svg
                      width="16"
                      height="16"
                      viewBox="0 0 24 24"
                      fill="#ffc107"
                    >
                      <path d="M12 2L15.09 8.26L22 9L17 14L18.18 22L12 19L5.82 22L7 14L2 9L8.91 8.26L12 2Z" />
                    </svg>
                    <svg
                      width="16"
                      height="16"
                      viewBox="0 0 24 24"
                      fill="#ffc107"
                    >
                      <path d="M12 2L15.09 8.26L22 9L17 14L18.18 22L12 19L5.82 22L7 14L2 9L8.91 8.26L12 2Z" />
                    </svg>
                    <svg
                      width="16"
                      height="16"
                      viewBox="0 0 24 24"
                      fill="#ffc107"
                    >
                      <path d="M12 2L15.09 8.26L22 9L17 14L18.18 22L12 19L5.82 22L7 14L2 9L8.91 8.26L12 2Z" />
                    </svg>
                    <svg
                      width="16"
                      height="16"
                      viewBox="0 0 24 24"
                      fill="#ffc107"
                    >
                      <path d="M12 2L15.09 8.26L22 9L17 14L18.18 22L12 19L5.82 22L7 14L2 9L8.91 8.26L12 2Z" />
                    </svg>
                    <svg
                      width="16"
                      height="16"
                      viewBox="0 0 24 24"
                      fill="#ffc107"
                    >
                      <path d="M12 2L15.09 8.26L22 9L17 14L18.18 22L12 19L5.82 22L7 14L2 9L8.91 8.26L12 2Z" />
                    </svg>
                    <span className="rating-number">4.8</span>
                  </div>
                  <p className="testimonial">
                    "A game changer for city travel!"
                  </p>
                </div>

                {/* 功能标签 - 简洁有力的文案 */}
                <div className="feature-tags">
                  <span className="tag">
                    <svg
                      width="18"
                      height="18"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                    >
                      <rect x="3" y="3" width="18" height="18" rx="2" ry="2" />
                      <circle cx="8.5" cy="8.5" r="1.5" />
                      <polyline points="21,15 16,10 5,21" />
                    </svg>
                    AI Trip Builder
                  </span>
                  <span className="tag">
                    <svg
                      width="18"
                      height="18"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                    >
                      <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z" />
                      <circle cx="12" cy="10" r="3" />
                    </svg>
                    Best Hotels & Spots
                  </span>
                  <span className="tag">
                    <svg
                      width="18"
                      height="18"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                    >
                      <polygon points="3,11 22,2 13,21 11,13 3,11" />
                    </svg>
                    Smart Navigation
                  </span>
                  <span className="tag">
                    <svg
                      width="18"
                      height="18"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                    >
                      <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />
                    </svg>
                    Expert Travel Chat
                  </span>
                </div>

                {/* 认证徽章 - 使用简洁图标 */}
                <div className="cert-badges-simple">
                  <span>
                    <svg
                      width="16"
                      height="16"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                    >
                      <path d="M12 2L14.5 9H22L16.5 14L18.5 22L12 17.5L5.5 22L7.5 14L2 9H9.5L12 2Z" />
                    </svg>
                    Civitas
                  </span>
                  <span>
                    <svg
                      width="16"
                      height="16"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                    >
                      <path d="M12 1L21 5V11C21 16.55 17.16 21.74 12 23C6.84 21.74 3 16.55 3 11V5L12 1Z" />
                    </svg>
                    Canada
                  </span>
                  <span>
                    <svg
                      width="16"
                      height="16"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                    >
                      <circle cx="12" cy="12" r="10" />
                      <polyline points="16,12 12,8 8,12" />
                      <line x1="12" y1="16" x2="12" y2="8" />
                    </svg>
                    FIT Network
                  </span>
                </div>
              </div>
            </div>
          </Container>
        </div>

        {/* City cards */}
        <Container
          fluid
          className="scroll-section-container"
          ref={cityCardsRef}
        >
          <h2
            className="city-section-title"

          >
            🌟 Pick a city and let’s whip up your custom adventure!
          </h2>
          {/* —— left arrow —— */}
          <button
            className="scroll-arrow scroll-arrow-left"
            onClick={scrollLeft}
          >
            ‹
          </button>

          {/* —— right arrow —— */}
          <button
            className="scroll-arrow scroll-arrow-right"
            onClick={scrollRight}
          >
            ›
          </button>

          <div className="horizontal-scroll" ref={scrollContainerRef}>
            {cityList.map((city) => (
              <FeaturedCard
                key={city.name}
                imgSrc={city.imgSrc}
                title={`${city.name} `}
                subtitle={city.subtitle}
              />
            ))}
          </div>
        </Container>

        {/* —— AI Welcome Prompt Section —— */}
        <div className="ai-welcome-section">
          <h1 className="ai-welcome-title">
            👋 Hey, I’m Concord – your AI travel planner
          </h1>
          <p className="ai-welcome-subtitle">
            Tell me what you want, and I’ll handle the rest: attractions, food,
            hotels, itineraries — in seconds.
          </p>

          <Container className="ai-input-container">
            <div className="ai-textarea-wrapper">
              <textarea
                placeholder="e.g. Design an unforgettable anniversary trip to Washington D.C."
                value={searchInput}
                onChange={(e) => setSearchInput(e.target.value)}
                onKeyDown={handleSearchKeyDown}
                className="ai-textarea"
                rows={4}
              />
              <button
                className="ai-send-icon-cute"
                onClick={handleSearchSubmit}
              >
                <i className="bi bi-send-fill"></i>
              </button>
            </div>

            <div className="ai-suggestion-buttons">
              <Button
                variant="outline-secondary"
                onClick={() =>
                  handleSuggestionClick(
                    "Create a new trip to Montreal for 4 nights with friends"
                  )
                }
              >
                <i className="bi bi-globe-americas me-2"></i>
                Create a new trip
              </Button>

              <Button
                variant="outline-secondary"
                onClick={() =>
                  handleSuggestionClick(
                    "Inspire me where to go this summer with a $2000 budget"
                  )
                }
              >
                <i className="bi bi-stars me-2"></i>
                Inspire me where to go
              </Button>

              <Button
                variant="outline-secondary"
                onClick={() =>
                  handleSuggestionClick("Weekend getaways near Toronto")
                }
              >
                <i className="bi bi-person-walking me-2"></i>
                City getaways
              </Button>

              <Button
                variant="outline-secondary"
                onClick={() => handleSuggestionClick("How does this work?")}
              >
                <i className="bi bi-info-circle me-2"></i>
                How it works
              </Button>
            </div>
          </Container>
        </div>

        {/* HERO section */}
        <section className="hero-section">
          <div className="hero-overlay">
            <div className="hero-text">
              <h1>Plan your next trip</h1>
              <p>
                "Create a 5-day family trip in Montreal with good food, fun
                local activities, cozy hotels, and flexible transportation — for
                next month"
              </p>
              <button className="hero-ask-btn">
                Ask <i className="bi bi-send-fill"></i>
              </button>
            </div>
          </div>
        </section>

        <Container fluid className="py-5 custom-container">
  <h2 className="text-center mb-5 custom-title">
    ✨ AI assistant for free independent travellers
  </h2>

  <Slider
  dots={true}
  infinite={false}
  speed={500}
  slidesToShow={3}
  slidesToScroll={1}
  responsive={[
    { breakpoint: 992, settings: { slidesToShow: 2 } },
    { breakpoint: 768, settings: { slidesToShow: 1 } },
  ]}
>
  {[
    {
      bgColor: "bg-start-chatting",
      img: "https://mindtrip.ai/cdn-cgi/image/w=384,format=webp,h=317,fit=cover/https://images.mindtrip.ai/web/hp-new-start-anywhere.png",
      title: "Start Chatting",
      text: "Our AI-powered chatbot knows your destination and creates a personalized travel plan — including sightseeing spots, dining options, transportation, and accommodations.",
      actions: ["Try it Now"],
    },
    {
      bgColor: "bg-customize-itinerary",
      img: "https://mindtrip.ai/cdn-cgi/image/w=750,format=webp,h=667,fit=cover/https://images.mindtrip.ai/web/4_Img.jpg",
      title: "Customize Your Itinerary",
      text: "Easily modify your itinerary on the go. Swap activities, add new ones, or purchase local attraction tickets directly through the platform.",
      actions: ["Play video", "Try it Now"],
    },
    {
      bgColor: "bg-local-guide",
      img: "https://mindtrip.ai/cdn-cgi/image/w=640,format=webp,h=512,fit=cover/https://images.mindtrip.ai/web/5_Img.jpg",
      title: "Your Local Guide",
      text: "Enjoy real-time assistance while you travel. Our AI guide provides up-to-date tourism information, reminders of your next stop, and flexible itinerary adjustments — all tailored to your preferences.",
      actions: ["Play video", "Try it Now"],
    },
    {
      bgColor: "bg-tourism-industry",
      img: "https://mindtrip.ai/cdn-cgi/image/w=640,format=webp,h=512,fit=cover/https://images.mindtrip.ai/web/6_Img.jpg",
      title: "Build for Tourism Industry",
      text: "We build knowledge base for each destination. We can collaborate with local businesses through marketing, recommendation, promotion, etc.",
      actions: ["Try it Now"],
    },
  ].map((card, idx) => (
    <div key={idx} className="px-3">
      <div className={`feature-card ${card.bgColor}`}>
        <div className="feature-card-image">
          <img src={card.img} alt={card.title} />
        </div>
        <div className="feature-card-text">
          <h5>{card.title}</h5>
          <p>{card.text}</p>
        </div>
        <div className="feature-card-actions">
          {card.actions.map((action, i) => (
            <Button
              key={i}
              variant="link"
              className="feature-card-btn"
              onClick={scrollToAiBox}
            >
              {action}
            </Button>
          ))}
        </div>
      </div>
    </div>
  ))}
</Slider>


          {/*How it works*/}

  <h2 className="how-it-title">
    🔍 See how I do it
  </h2>
            <p className="how-it-subtitle">
              Try one of these asks and let the vacation inspo roll in.
            </p>

            <div className="how-it-layout">
              <div className="how-it-prompts">
                {/* 左侧 Bubble 示例 */}
                <div
                  className={`how-it-bubble ${
                    activeBubble === "inspiration" ? "active" : ""
                  }`}
                  onClick={() => setActiveBubble("inspiration")}
                >
                  <span className="how-it-tag inspiration">Inspiration</span>
                  <p>
                    "Show me videos for where I can go for a scenic walk or food
                    tour in Montreal with my family"
                  </p>
                </div>

                <div
                  className={`how-it-bubble ${
                    activeBubble === "restaurants" ? "active" : ""
                  }`}
                  onClick={() => setActiveBubble("restaurants")}
                >
                  <span className="how-it-tag flights">Restaurants</span>
                  <p>
                    "Find me restaurants under $30 per person in Montreal for a
                    casual dinner with friends"
                  </p>
                </div>

                <div
                  className={`how-it-bubble ${
                    activeBubble === "hotels" ? "active" : ""
                  }`}
                  onClick={() => setActiveBubble("hotels")}
                >
                  <span className="how-it-tag hotels">Hotels</span>
                  <p>
                    <strong>
                      Search for a luxury boutique hotel in Old Montreal with a
                      historic vibe and spa access
                    </strong>
                  </p>
                </div>

                <div
                  className={`how-it-bubble ${
                    activeBubble === "trips" ? "active" : ""
                  }`}
                  onClick={() => setActiveBubble("trips")}
                >
                  <span className="how-it-tag trips">Trips</span>
                  <p>
                    "Build a 5-day romantic trip to Montreal in the fall to see
                    the colorful leaves and explore cozy cafés with my partner"
                  </p>
                </div>
              </div>

              {/* 右侧酒店示意卡片 */}
              <div className="how-it-card">
                {activeBubble === "hotels" && <HotelPreview />}
                {activeBubble === "restaurants" && <RestaurantPreview />}
                {activeBubble === "inspiration" && <InspirationPreview />}
                {activeBubble === "trips" && <TripPreview />}
              </div>
            </div>

          <section className="travel-sidekick-section">
            <div className="sidekick-content">
              <div className="sidekick-image-wrapper">
                <img
                  src="/assets/banner.jpg"
                  alt="AI Sidekick"
                  className="sidekick-avatar"
                />
              </div>
              <div className="sidekick-text">
                <h2>Concord — the only trip planner you’ll ever need</h2>
                <p>
                  Looking to escape on the perfect trip — birthday bash, couples
                  getaway, family adventure, or just an excuse to eat good food
                  in a cool place? You’re in the <em>exact</em> right spot. Just
                  tell me what’s on your mind — dream destinations, chill
                  hotels, fun road trips, or the best flights under your budget
                  — and I’ll whip up a custom plan faster than you can pack your
                  suitcase. Whether you’re rolling solo, traveling with your
                  better half, or herding kids through airports, I’ve got you
                  covered. No more 37 open tabs and half-baked Google Docs — I’m
                  your one-and-only AI travel buddy. Get ready for bold ideas,
                  wow-worthy videos, and seriously smooth trip vibes. Now let’s
                  make those vacation days count.
                </p>

                <button className="sidekick-cta">Create a new trip</button>
              </div>
            </div>
          </section>

          <section className="feature-grid-section">
            <h2
              className="feature-title"
            >
              Everything you need. All in one.
            </h2>
            <div className="feature-grid">
              {features.map((item, index) => (
                <div key={index} className="feature-card">
                  <div className="feature-icon">
                    {item.icon}
                    {item.soon && (
                      <span className="coming-soon">Coming soon</span>
                    )}
                  </div>
                  <h3>{item.title}</h3>
                  <p>{item.description}</p>
                </div>
              ))}
            </div>
          </section>

          {/* partner */}
        </Container>
        <section className="partner-section">
          <img
            src="/assets/logocity.jpg"
            alt="Partner Icon"
            className="partner-icon"
          />
          <h2 className="partner-title">Partner with Concord.</h2>
          <p className="partner-description">
            Want to help bring unique travel plans to life using cutting-edge
            tech or exclusive local content?
          </p>
          <button className="partner-btn">Become a Partner</button>
        </section>
      </div>
    </>
    ////empty tag
  );
};

export default MainPage;
